import React from 'react';
import { Card, Typography, Box, Grid, Button } from '@mui/material';
import Iconify from 'src/components/Iconify';

const CardComponent = ({
  count,
  title,
  icons,
  iconStyle,
  boxStyle,
  mainCardStyle,
  countStyle,
  onClick,
  disabled
}) => {
  return (
    <Button
      disabled={disabled}
      onClick={onClick} // Replace with your click handler
      sx={{
        ...mainCardStyle,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0px 15px',
        height: '110px',
        borderRadius: '16px',
        width: '100%',
        backgroundColor: '#f7f9fc',
        position: 'relative',
        overflow: 'hidden',
        marginBottom: 2
      }}
      xs={12}
      sm={5.8}
      md={3.8}
    >
      {/* Text Section */}
      <Box>
        <Typography variant="h5" component="div" style={{ ...countStyle, textAlign: 'left' }}>
          {count}
        </Typography>
        <Typography color="text.secondary" style={{ fontSize: 14 }}>
          {title}
        </Typography>
      </Box>

      {/* Yellow Background Design */}
      <Box
        sx={{
          ...boxStyle,
          position: 'absolute',
          right: -50,
          top: -20,
          width: '120px',
          height: '110px',
          borderRadius: '20px',
          transform: 'rotate(40deg)',
          zIndex: 0,
          borderBottomRightRadius: 0
        }}
      ></Box>

      {/* Icon Section */}
      <Box
        sx={{
          zIndex: 1,
          width: '40px',
          height: '40px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: -5,
          marginRight: 1.5
        }}
      >
        <Iconify icon={icons} sx={iconStyle} />
      </Box>
    </Button>
  );
};

export default CardComponent;
